export default __webpack_public_path__ + "static/media/fMaltoBuza43.4c79d67d.png";